<div class=" w-full h-full overflow-hidden">
    <div class="flex flex-col">
        <div class="flex justify-between mb-1">
            <h3 class="site-name-color">{{dashboardService.translate('Select Inventory')}} </h3>
            <span class="flex items-center " mat-dialog-close mat-icon-button
                style="cursor: pointer">
                <mat-icon [svgIcon]="'custom:close'"></mat-icon>
            </span>
        </div>
    </div>
    <hr class="w-full my-4">
    <!-- //configuration files-->
    <div class="ml-auto mr-10" style="margin-bottom: 11px !important;" *ngIf="!isMaster" >
        <span *ngIf="displayDayNightToggle" class="relative" style="margin-right: 7px !important;top: -22px !important;">{{dashboardService.translate('DAY')}}</span>
       <span *ngIf="displayDayNightToggle" class="shoulder-btn cursor-pointer" (click)="onDayClick()"></span>
       <span *ngIf="displayDayNightToggle" class="center-combined-shoulder-median" (click)="onDayAndNightClick()"></span>
       <span *ngIf="displayDayNightToggle" class="median-btn cursor-pointer" (click)="onNightClick()"></span>
       <span *ngIf="isWorkorder && displayDayNightToggle" class="center-bg" [id]="'centerbg-110'"></span>       
       <span *ngIf="!isWorkorder && displayDayNightToggle" class="center-bg" [id]="'centerbg-10'"></span>       
       <span *ngIf="displayDayNightToggle" class="relative" style="margin-left: 69px !important;top: -23px !important;">{{dashboardService.translate('NIGHT')}}</span>

       <mat-label *ngIf="displayIssueType" [ngClass]=" !displayDayNightToggle ? 'issue-type-left' : 'issue-type-custom'">{{dashboardService.translate("Select Issue Types")}}</mat-label>
        <mat-form-field *ngIf="displayIssueType" [ngClass]="!displayDayNightToggle ? 'search-issue-type-left' : 'search-issue-type-custom'" class="left-6">
            <mat-select [placeholder]="selectedIssueTypeCount" [(value)]="selectedIssueTypes" >
                <mat-option *ngFor="let data of issueTypeData">
                    <mat-checkbox [checked]="isCheckedIssueType(data)" (click)="$event.stopPropagation()" (change)="onIssueTypeClick(data)">
                      {{ data }}
                    </mat-checkbox>
                  </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="flex flex-col h-3/4 w-full relative"  [ngClass]="(isMaster || (!displayDayNightToggle && !displayIssueType))? '' : 'custom-top'" >
        <mat-form-field class="flex-auto gt-xs:pr-3 m-0 mb-0 max-h-15 w-full">
            <input matInput class="w-full" [placeholder]="dashboardService.translate('Search Filter')+'...'"
                (input)="onSearchFilter($event.target.value)">
            <mat-icon class="icon-size-5" matSuffix [svgIcon]="'heroicons_solid:search'"></mat-icon>
        </mat-form-field>

        <div class="flex w-full">
            <div class="w-full flex flex-row">
                <div class="w-1/2">
                    <mat-checkbox class="py-2 pl-5 w-full"
                    
                        (change)="onSelectAllAssetTypesClick($event.checked)">{{dashboardService.translate('Select
                        All')}}</mat-checkbox>
                </div>
                <div class="w-1/2">
                    <mat-checkbox class="py-2 pl-5 w-full"
                        (change)="onSelectAllAssetsClick($event.checked)">{{dashboardService.translate('Select
                        All')}}
                    </mat-checkbox>
                </div>
            </div>
        </div>
        <div class="flex justify-center flex-row w-full h-[93%]" style="min-height: calc(100vh - 560px) !important;">
            <div class="w-full flex flex-col ">
                <div class="relative sm:max-h-120 divide-y overflow-y-auto bg-card w-full h-full">
                    <div class="text-center w-full py-2 pt-0" *ngIf="!filters || !filters.length">
                        <h3>No Filters Available.</h3>
                    </div>
                    <div class="flex flex-row border-t-2 w-full h-full" *ngIf="filters && filters.length">

                        <div class=" w-1/2 border-r-2 h-full">
                            <div class=" flex flex-col w-full">
                                <div class="w-full flex flex-col">
                                    <span class="text-md py-2 border-b-2 pl-5  w-full "
                                        [ngClass]="selectedAssetType && assetType && selectedAssetType.asset_type_name ==assetType.asset_type_name?'bg-hover':''"
                                        *ngFor="let assetType of filters">
                                        <mat-checkbox [checked]="isAssetTypeChecked(assetType)"
                                            (change)="onAssetTypeClick(assetType,$event.checked)"></mat-checkbox>
                                        <span (click)="onAssetClick(assetType)"
                                            class="w-full cursor-pointer">{{displayAssetTypeName(assetType.asset_type_name) | titlecase}}
                                        <div *ngIf="assetType.selected_asset_count > 0" class="count-border">
                                            <span class="selection-count">
                                                {{assetType.selected_asset_count}}
                                            </span>
                                        </div>
                                    </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class=" w-1/2 overflow-auto " [ngClass]="isMaster? 'full-height' : 'min-height'">
                            <div class=" flex flex-col ">
                                <div class="w-full" *ngIf=" selectedAssetType" style="transition: 0.6s">
                                    <mat-checkbox class="py-2 pl-5 w-full" (change)="onSelectFilterChange($event,asset)"
                                        [checked]="isChecked(asset)" *ngFor="let asset of selectedAssetType.assets">
                                        {{dashboardService.translate(asset.asset_name.replace('_', ' ')) |
                                        titlecase}}
                                        <!-- <span class="text-xs" style="color: #808080 !important;">({{asset.asset_name.replace('_', ' ')}})</span> -->
                                    </mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class=" mb-4 mt-3 mr-4 flex justify-end">
                    <button (click)="onSubmitClick()" class="bg-[#142653] hover:bg-[#0e1836] text-white font-bold py-2 px-4 rounded">
                        {{dashboardService.translate('Apply')}}
                    </button>
                </div>
            </div>

        </div>
    </div>
</div>